import Vue from 'vue';

export default Vue.extend({
    data() {
        return {
            error: '',
        }
    },

    methods: {
        clearError() {
            this.error = '';
        },

        setError(error: string) {
            this.error = error;
        }
    }
});
